/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="modal-header">\n  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\n  <h2>\n    Select Location\n  </h2>\n</div>\n\n<div class="modal-body">\n  \n  ';
 _.each(data.folders, function(folder){ ;
__p += '\n    ';
 if(data.view.selectedItemType == "asset" || !folder.idInParentTree(data.view.selectedItemId)) { ;
__p += '\n        <div data-folder-id="' +
__e(folder.get('id')) +
'" \nclass="folder-choice action-select-folder\n ' +
__e(folder.isExpandable(data.view.selectedItemType, data.view.selectedItemId) ? 'expandable' : '') +
' \n ' +
__e(folder.shouldDisplayInFolderModal() ? '' : 'hide') +
' \n ' +
__e(folder.isExpanded() ? 'expanded' : '') +
'" \nindent="' +
__e(folder.getParents().length) +
'" data-parent-ids=' +
__e(folder.getParentIds()) +
'>\n          <span class="action-expand expand-icon-wrapper">\n            <i class="fa fa-plus-square-o"></i>\n            <i class="fa fa-minus-square-o"></i>\n          </span>\n          <i class="fa fa-folder"></i>\n          ' +
__e(folder.getName()) +
'\n    \n          ';
 if (data.view.shouldShowAsCurrentLocation(folder)){ ;
__p += '\n            <span class="current-indicator">\n              Current Location\n            </span>\n          ';
 } else if(data.view.selectedItemType == "folder" && data.view.selectedItemId == folder.get('id')) { ;
__p += '\n            <span class="current-indicator">\n              Current Folder\n            </span>\n          ';
 } ;
__p += '\n        </div>\n    ';
 } ;
__p += '\n\n  ';
 }); ;
__p += '\n  \n</div>\n\n<div class="modal-footer">\n  <div class="cancel-button" data-dismiss="modal" aria-hidden="true">\n    Cancel\n  </div>\n  <div class="main-modal-button action-submit" style="display: none;">\n    Move\n  </div>\n</div>';
return __p
}
